<template>
<div class="view-port clearfix quickview-notes" id="note-views">
  <!-- BEGIN Note List !-->
  <div class="view list" id="quick-note-list">
    <div class="toolbar clearfix">
      <ul class="pull-right ">
        <li>
          <a href="#" class="delete-note-link"><i class="fa fa-trash-o"></i></a>
        </li>
        <li>
          <a href="#" class="new-note-link" data-navigate="view" data-view-port="#note-views" data-view-animation="push"><i class="fa fa-plus"></i></a>
        </li>
      </ul>
      <button class="btn-remove-notes btn btn-xs btn-block hide"><i class="fa fa-times"></i> Delete</button>
    </div>
    <ul>
      <Note :note="note" :key="note.id" v-for="note in notes" />
    </ul>
  </div>
  <!-- END Note List !-->
  <NoteEditor />
</div>
</template>

<script>
  import NoteModel from '../models/note.js';
  import Note from './note.vue';
  import NoteEditor from './note_editor.vue';

  export default {
    name: "Notes",    
    components: {
      Note,
      NoteEditor
    },
    data: () => ({
      notes: [
        new NoteModel({id: '1', content: 'Lorem ipsum dolorem', createdAt: new Date() }),
        new NoteModel({id: '2', content: 'Lorem ipsum dolorem', createdAt: new Date() }),
        new NoteModel({id: '3', content: 'Lorem ipsum dolorem', createdAt: new Date() }),
        new NoteModel({id: '4', content: 'Lorem ipsum dolorem', createdAt: new Date() }),
        new NoteModel({id: '5', content: 'Lorem ipsum dolorem', createdAt: new Date() }),
        new NoteModel({id: '6', content: 'Lorem ipsum dolorem', createdAt: new Date() })        
      ]
    })
  }
</script>


// WEBPACK FOOTER //
// notes.vue?f112383c